/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unneeded-ternary */
import React from 'react';
import { Field, Form } from 'formik';
import { toast } from 'react-toastify';
import { useLazyQuery } from '@apollo/client';
import { Button, Col, Label, Row } from 'reactstrap';
import {
  ADD_EDIT_CONSTANT,
  currencyToLocal,
  dynamicButtonHeading,
} from 'utils/constants';
import FormikInputField from 'components/Fields/FormikInputField';
import CardWithTitle from 'components/CardWithTitle';
import LoadingButton from 'components/common/LoadingButton';
import CouponCodeField from 'components/CouponCodeField';
import {
  getCurrentDateISO,
  getDaysBetweenDates,
} from 'components/Drawers/components/VendorDetailsDrawer/constant';
import { CALCULATE_SUBSCRIPTION_AMOUNT } from 'pages/SubscriptionPlans/subscriptionPlanGraphQL';
import VendorSubscriptionPlan from '../../../VendorSubscribe/components/VendorSubscriptionPlan';

const VendorSubscribeAddOnForm = (props) => {
  const {
    handleSubmit,
    drawerToggle,
    isSubmitting,
    dirty,
    isValid,
    type,
    setFieldValue,
    values,
    id,
    row,
    calculateAmount,
    setCalculateAmount,
    currency,
    deactivationDate,
  } = props;

  const [calculateSubscriptionAmount, { loading }] = useLazyQuery(
    CALCULATE_SUBSCRIPTION_AMOUNT,
  );

  const handleCalculateAmount = async (subId) => {
    try {
      const response = await calculateSubscriptionAmount({
        variables: {
          currentUserSubscriptionId:
            type === ADD_EDIT_CONSTANT.EDIT ? row?.id : '',
          couponCode: values?.coupon?.code,
          subscriptionPlanId: subId ? subId : parseInt(values?.id),
          traderId: id,
        },
      });

      if (response?.data?.calculateSubscriptionAmount)
        setCalculateAmount(response?.data?.calculateSubscriptionAmount);
      else {
        response?.errors.map(({ exception }) => {
          toast.error(exception?.message);
        });
      } // if (data?.calculateSubscriptionAmount?.status === 204)
      //   toast.error(data?.calculateSubscriptionAmount?.message);
      // if (data?.calculateSubscriptionAmount?.status === 200)
      //   toast.success(data?.calculateSubscriptionAmount?.message);
    } catch (err) {
      console.error(err);
      toast.error(err);
    }
  };
  const handleSubscriptionPlanChange = (value) => {
    setFieldValue('subscriptionPlan', {
      id: value?.id,
      label: value?.planName,
    });
    // setFieldValue('duration', value?.duration);
    // setFieldValue('price', value?.price);
    // setFieldValue('id', value?.id);

    setFieldValue('discountedAmount', value?.discountedAmount, false);
    setFieldValue('duration', value?.duration, false);
    setFieldValue('price', value?.price, false);
    setFieldValue('id', value?.id, false);

    handleCalculateAmount(value?.id);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle title="Subscription Details">
        <Row>
          <Col sm={5}>
            <VendorSubscriptionPlan
              label="Subscription Plan"
              name="subscriptionPlan"
              type="select"
              onChange={handleSubscriptionPlanChange}
              currency={currency}
              op="EQ"
              required
            />
          </Col>

          <Col sm={5}>
            <Field
              label="Price"
              name="price"
              type="number"
              component={FormikInputField}
              disabled
            />
          </Col>

          <Col sm={5}>
            <div className="d-flex align-items-center">
              <div className="w-100">
                <CouponCodeField
                  label="Coupon Code"
                  name="coupon"
                  type="select"
                  onChange={(value) =>
                    setFieldValue('coupon', {
                      id: value?.id,
                      code: value?.code,
                    })
                  }
                  isDisabled={!values?.subscriptionPlan?.id}
                  filter={[
                    {
                      key: 'id',
                      value: currency === 'INR' ? '101' : '233',
                      joinAttributeName: 'currency',
                      type: 'INT',
                      op: 'EQ',
                    },
                  ]}
                />
              </div>
              <Button
                color="primary"
                size="sm"
                className="ms-3"
                onClick={() => handleCalculateAmount(null)}
                disabled={!values?.coupon?.id}
              >
                Apply
              </Button>
            </div>
          </Col>
          {/* 
          <Col sm={5}>
            <Field
              label="Mode of Payment"
              name="mode_of_payment"
              type="select"
              data={[
                { id: 'ONLINE', label: 'ONLINE' },
                { id: 'CASH', label: 'CASH' },
              ]}
              component={ReactSelect}
              keys={{ id: 'id', label: 'label' }}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.label}
              required
            />
          </Col> */}
        </Row>
      </CardWithTitle>

      {calculateAmount && values ? (
        <CardWithTitle className="subcription-card" title="Calculate Amount">
          <div className="border-bottom mb-2">
            {deactivationDate && row?.isTrial ? (
              <div className="mb-2 ">
                <Label className="text-uppercase fw-semibold text-success">
                  Pro Rata Days{' '}
                </Label>{' '}
                <span className="dash-line">-</span>
                <span className="fw-semibold text-success">
                  {' '}
                  {`${getDaysBetweenDates(getCurrentDateISO(), deactivationDate)} days`}
                </span>
              </div>
            ) : (
              ''
            )}
            <div className="mb-2">
              <Label className="text-uppercase"> Amount </Label>{' '}
              <span className="dash-line">-</span>
              <span className="fw-semibold">
                {' '}
                {currencyToLocal(values?.price?.toFixed(2), currency)}
              </span>
            </div>
            {/* {values?.discountedAmount > 0 && ( */}
            <div className="mb-2">
              <Label className="text-uppercase"> Plan Discount </Label>{' '}
              <span className="dash-line">-</span>
              <span className="fw-semibold">
                -
                {currencyToLocal(
                  (values?.price - values?.discountedAmount).toFixed(2),
                  currency,
                )}
              </span>
            </div>
            {/* // )} */}
            {/* {calculateAmount?.couponAmount > 0 && ( */}
            <div className="mb-2">
              <Label className="text-uppercase">coupon Amount </Label>{' '}
              <span className="dash-line">-</span>
              <span className="fw-semibold">
                -{currencyToLocal(calculateAmount?.couponAmount, currency)}
              </span>
            </div>
            {/* // )}
            // {calculateAmount?.proRataAmount > 0 && ( */}
            <div className="mb-2">
              <Label className="text-uppercase">pro Rata Amount </Label>{' '}
              <span className="dash-line">-</span>
              <span className="fw-semibold">
                -
                {currencyToLocal(
                  calculateAmount?.proRataAmount.toFixed(2),
                  currency,
                )}
              </span>
            </div>
            {/* // )} */}
          </div>
          <div className="mb-2">
            <Label className="text-uppercase"> Taxable Value </Label>{' '}
            <span className="dash-line">-</span>
            <span className="fw-semibold">
              {' '}
              {currencyToLocal(
                calculateAmount?.subscriptionAmount.toFixed(2),
                currency,
              )}
            </span>
          </div>
          {/* {calculateAmount?.sGstAmount > 0 && ( */}
          <div className="mb-2">
            <Label className="text-uppercase">sGst Amount </Label>{' '}
            <span className="dash-line">-</span>
            <span className="fw-semibold">
              {' '}
              {`${currency === 'INR' ? '₹' : '$'} ${calculateAmount?.sGstAmount.toFixed(
                2,
              )}`}
            </span>
          </div>
          {/* // )} */}
          {/* {calculateAmount?.cGstAmount > 0 && ( */}
          <div className="mb-2">
            <Label className="text-uppercase">cGst Amount </Label>{' '}
            <span className="dash-line">-</span>
            <span className="fw-semibold">
              {' '}
              {currencyToLocal(
                calculateAmount?.cGstAmount.toFixed(2),
                currency,
              )}
            </span>
          </div>
          {/* // )} */}
          {/* {calculateAmount?.iGstAmount > 0 && ( */}
          <div className="mb-2">
            <Label className="text-uppercase">iGst Amount </Label>{' '}
            <span className="dash-line">-</span>
            <span className="fw-semibold">
              {' '}
              {currencyToLocal(
                calculateAmount?.iGstAmount.toFixed(2),
                currency,
              )}
            </span>
          </div>
          {/* )} */}

          <div className="mb-2">
            <Label className="text-uppercase">grand Total </Label>{' '}
            <span className="dash-line">-</span>
            <span className="fw-semibold">
              {' '}
              {currencyToLocal(
                calculateAmount?.grandTotal.toFixed(2),
                currency,
              )}
            </span>
          </div>
        </CardWithTitle>
      ) : (
        ''
      )}
      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          onClick={() => drawerToggle('', ADD_EDIT_CONSTANT.ADD)}
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
        >
          Cancel
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting || loading}
          disabled={!isValid || !dirty || isSubmitting || loading}
          color="warning"
          size="sm"
          type="submit"
        >
          {dynamicButtonHeading(type)}
        </LoadingButton>
      </div>
    </Form>
  );
};

export default VendorSubscribeAddOnForm;
